<template>
  <div>
    <!-- 添加通道区域 -->
    <a-card style="margin-bottom: 24px">
      <a-form layout="inline">
        <a-form-item label="选择账号：">
          <a-select
            v-model:value="selectedAccount"
            placeholder="-- 选择账号 --"
            style="width: 180px"
          >
            <a-select-option
              v-for="item in accountList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="选择域名：">
          <a-select
            v-model:value="selectedDomain"
            placeholder="-- 选择域名 --"
            style="width: 280px"
          >
            <a-select-option
              v-for="item in domainList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="通道后缀：">
          <a-radio-group v-model:value="createIsSuffix">
            <a-radio :value="1">带</a-radio>
            <a-radio :value="0">不带</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="createChannel">创建通道</a-button>
        </a-form-item>
      </a-form>
    </a-card>

    <!-- 通道广告管理表格 -->
    <a-card title="通道广告管理">
      <a-form layout="inline" style="margin-bottom: 16px">
        <a-form-item label="按ID搜索">
          <a-input
            v-model:value="searchId"
            placeholder="输入通道ID"
            style="width: 120px"
          />
        </a-form-item>
        <!-- 选择账号搜索 -->
        <a-form-item label="选择账号：">
          <a-select v-model:value="searchAccount" placeholder="-- 选择账号 --">
            <a-select-option
              v-for="item in accountList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="fetchTableData">搜索</a-button>
          <a-button style="margin-left: 8px" @click="resetSearch"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
      <x-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        rowKey="id"
        bordered
        :pagination="false"
      >
        <template #url="{ record }">
          <a-typography-text
            :copyable="{
              text:
                record.isSuffix === 0
                  ? record.url
                  : record.url + `?channel=${record.id}`,
            }"
          >
            {{
              record.isSuffix === 0
                ? record.url
                : record.url + `?channel=${record.id}`
            }}
          </a-typography-text>
        </template>
        <template #action="{ record }">
          <a-button type="info" @click="openAdDialog(record)"
            >查看广告</a-button
          >
        </template>
      </x-table>
      <a-pagination
        :current="pageNo"
        :page-size="pageSize"
        :total="total"
        @change="onPageChange"
        style="margin-top: 16px; text-align: right"
      />
    </a-card>

    <!-- 广告列表弹窗 -->
    <x-dialog
      :visible="adDialogVisible"
      :title="adDialogTitle"
      xWidth="1000px"
      @cancel="closeAdDialog"
    >
      <div style="margin-bottom: 16px; text-align: right">
        <a-button type="primary" @click="openAddAdDialog">添加</a-button>
      </div>
      <x-table
        :columns="adColumns"
        :data-source="adTableData"
        :loading="adLoading"
        rowKey="id"
        bordered
        :pagination="false"
      />
      <a-pagination
        :current="adPageNo"
        :page-size="adPageSize"
        :total="adTotal"
        @change="onAdPageChange"
        style="margin-top: 16px; text-align: right"
      />
    </x-dialog>

    <!-- 添加广告弹窗 -->
    <x-dialog
      :visible="addAdDialogVisible"
      title="添加广告"
      xWidth="400px"
      @cancel="closeAddAdDialog"
      @confirm="handleAddAd"
      :confirmLoading="addAdLoading"
    >
      <a-form
        layout="vertical"
        :model="adForm"
        :rules="adFormRules"
        ref="adFormRef"
      >
        <a-form-item label="广告标题" name="title" required>
          <a-input v-model:value="adForm.title" placeholder="请输入广告标题" />
        </a-form-item>
        <a-form-item label="广告ID" name="advertisingId" required>
          <a-input
            v-model:value="adForm.advertisingId"
            placeholder="请输入广告ID"
          />
        </a-form-item>
        <a-form-item label="广告KEY" name="advertisingKey" required>
          <a-input
            v-model:value="adForm.advertisingKey"
            placeholder="请输入广告KEY"
          />
        </a-form-item>
        <!-- <a-form-item label="通道后缀" name="isSuffix">
          <a-radio-group v-model:value="adForm.isSuffix">
            <a-radio :value="1">添加</a-radio>
            <a-radio :value="0">不添加</a-radio>
          </a-radio-group>
        </a-form-item> -->
      </a-form>
    </x-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";
import { message } from "ant-design-vue";
import XTable from "@/components/XATable.vue";
import {
  channelAdmDateList,
  channelList,
  channelAdmDateCreate,
  channelAccountList,
  channelDomainList,
  channelSave,
} from "@/api/api";
import XDialog from "@/components/XDialog.vue";
import type { FormInstance } from "ant-design-vue";

const props = defineProps({
  accountId: {
    type: String,
    default: "",
  },
  activeKey: {
    type: String,
    default: "1",
  },
  isRefresh: {
    type: Boolean,
    default: false,
  },
});

const accountList = ref<any[]>([]);
const domainList = ref<any[]>([]);
const selectedAccount = ref();
const selectedDomain = ref();
const searchId = ref("");
const searchAccount = ref();
const tableData = ref([]);
const loading = ref(false);
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const createIsSuffix = ref(1);

const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 100 },
  { title: "账号", dataIndex: "accountName", key: "accountName" },
  { title: "通道地址", dataIndex: "url", key: "url", slot: true },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
  { title: "广告数量", dataIndex: "count", key: "count", width: 100 },
  { title: "操作", dataIndex: "action", key: "action", width: 120 },
];

watch(
  () => props.accountId,
  (newVal) => {
    searchAccount.value = newVal;
    fetchTableData();
  }
);
watch(
  () => props.isRefresh,
  (cur, old) => {
    fetchTableData();
  }
);
watch(
  () => props.activeKey,
  (cur, old) => {
    if (cur === "1") {
      getAccountList();
      getDomainList();
    }
  }
);
const fetchTableData = async () => {
  loading.value = true;
  try {
    const params: any = {
      pageNo: pageNo.value,
      pageSize: pageSize.value,
    };
    if (searchId.value) params.id = searchId.value;
    if (searchAccount.value) params.accountId = searchAccount.value;
    const res = await channelList(params);
    tableData.value = res.data.records || [];
    total.value = res.data.total || 0;
  } catch (e) {
    message.error("获取数据失败");
  } finally {
    loading.value = false;
  }
};

const createChannel = async () => {
  if (!selectedAccount.value || !selectedDomain.value) {
    message.warning("请选择账号和域名");
    return;
  }
  const selectedDomainObj = domainList.value.find(
    (item) => item.id === selectedDomain.value
  );
  const url = selectedDomainObj ? selectedDomainObj.name : "";
  const params = {
    accountId: selectedAccount.value,
    url,
    isSuffix: createIsSuffix.value,
    // 其他字段如有
  };
  const res = await channelSave(params);
  if (res.code === "200") {
    message.success("创建通道成功");
    fetchTableData();
  } else {
    message.error(res.msg || "创建通道失败");
  }
};

const adDialogVisible = ref(false);
const adTableData = ref([]);
const adLoading = ref(false);
const adPageNo = ref(1);
const adPageSize = ref(10);
const adTotal = ref(0);
const currentChannel = ref<any>(null);
const addAdDialogVisible = ref(false);
const adForm = ref({
  advertisingId: "",
  advertisingKey: "",
  title: "",
  //   isSuffix: 1,
  channelId: "",
});
const adFormRef = ref<FormInstance>();
const addAdLoading = ref(false);

const adColumns = [
  {
    title: "广告ID",
    dataIndex: "advertisingId",
    key: "advertisingId",
    width: 180,
  },
  { title: "广告KEY", dataIndex: "advertisingKey", key: "advertisingKey" },
  { title: "标题", dataIndex: "title", key: "title" },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
  // 可根据实际接口补充更多字段
];

const adFormRules = {
  advertisingId: [{ required: true, message: "请输入广告ID" }],
  advertisingKey: [{ required: true, message: "请输入广告KEY" }],
  title: [{ required: true, message: "请输入广告标题" }],
};

const openAdDialog = (record: any) => {
  currentChannel.value = record;
  adDialogVisible.value = true;
  adPageNo.value = 1;
  fetchAdTableData();
};
const closeAdDialog = () => {
  adDialogVisible.value = false;
  fetchTableData();
};
const fetchAdTableData = async () => {
  if (!currentChannel.value) return;
  adLoading.value = true;
  try {
    const params: any = {
      id: currentChannel.value.id,
      pageNo: adPageNo.value,
      pageSize: adPageSize.value,
    };
    const res = await channelAdmDateList(params);
    adTableData.value = res.data.records || [];
    adTotal.value = res.data.total || 0;
  } catch (e) {
    message.error("获取广告列表失败");
  } finally {
    adLoading.value = false;
  }
};
const onAdPageChange = (page: number) => {
  adPageNo.value = page;
  fetchAdTableData();
};
const handleAddAd = async () => {
  if (!adFormRef.value) return;
  try {
    await adFormRef.value.validate();
    addAdLoading.value = true;
    const params = {
      ...adForm.value,
      channelId: currentChannel.value?.id,
    };
    const res = await channelAdmDateCreate(params);
    if (res.code === "200") {
      message.success("添加成功");
      closeAddAdDialog();
      fetchAdTableData();
    } else {
      message.error(res.msg);
    }
  } catch (e) {
    // 校验失败自动提示，无需额外处理
  } finally {
    addAdLoading.value = false;
  }
};
const openAddAdDialog = () => {
  addAdDialogVisible.value = true;
  adForm.value = {
    advertisingId: "",
    advertisingKey: "",
    title: "",
    isSuffix: 1,
    channelId: currentChannel.value?.id,
  };
  adFormRef.value?.resetFields();
};
const closeAddAdDialog = () => {
  addAdDialogVisible.value = false;
};

const onPageChange = (page: number) => {
  pageNo.value = page;
  fetchTableData();
};

const adDialogTitle = computed(() => {
  return currentChannel.value
    ? `广告列表（通道ID: ${currentChannel.value.id}）`
    : "广告列表";
});

const resetSearch = () => {
  searchId.value = "";
  searchAccount.value = undefined;
  fetchTableData();
};

onMounted(() => {
  getAccountList();
  getDomainList();
  fetchTableData();
});
const getAccountList = () => {
  channelAccountList({ pageNo: 1, pageSize: 1000 }).then((res) => {
    accountList.value = (res.data.records || []).map((item: any) => ({
      id: item.id,
      name: item.accountName,
    }));
  });
};
const getDomainList = () => {
  channelDomainList({ pageNo: 1, pageSize: 1000 }).then((res) => {
    domainList.value = (res.data.records || []).map((item: any) => ({
      id: item.id,
      name: item.hostName,
    }));
  });
};
</script>

<style scoped>
.ant-card {
  background: #fff;
}
</style>
